<div class="container-fluid">
    <div class="row">
        <div class="col-md-3">
            <a routerLink="/naac/dvv/criteria5"> <i class="fas fa-long-arrow-alt-left"></i> Go Back</a>
            <nav id="secondary-navigation">
                <!-- Header -->
                <header class="header">
                    <h5>5.3.1</h5>
                </header>
                <!-- /Header -->
                <ul>
                    <li class="one">
                        <a (click)="changeRoute('1')">Revised data in the data template of awards_medals in sports and cultural activities_1</a>
                    </li>
                    <li class="two">
                        <a (click)="changeRoute('2')">Revised data of Awards_medals in sports and cultural activities event wise_2</a>
                    </li>
                    <li class="three">
                        <a (click)="changeRoute('3')">E-copies of awards letters of sports and cultural_5 years_4</a>
                    </li>
                </ul>
            </nav>
        </div>
        <div class="col-md-9">
            <div id="five-two-one" *ngIf="showTable">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="card shadow-lg">
                                <h4 class="card-title text-center" *ngIf="heading1">E-copies of awards letters of sports and cultural_5 years_4</h4>
                                <div class="card-body text-justify">
                                    <table class="table table-bordered table-hover">
                                        <thead>
                                            <tr>
                                                <!-- <th scope="col">S.NO.</th> -->
                                                <th scope="col">TITLE</th>
                                                <th scope="col">URL</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let item of result; let i = index;">
                                                <!-- <th scope="row">{{i+41}}</th> -->
                                                <td class="title">{{item.title}}</td>
                                                <td class="link"><a href="{{item.link}}" target="_blank"><i
                                                            class="fas fa-eye"></i></a> </td>
                                            </tr>

                                        </tbody>
                                    </table>
                                </div>
                            </div>

                        </div>
                    </div>


                </div>
            </div>

            <div class="container-fluid pdf" *ngIf="!showTable">
                <div class="row">
                    <div class="col-12">
                        <div class="card card-body">
                            <h5 class="card-title text-center" *ngIf="heading2">Revised data in the data template of awards_medals in sports and cultural activities_1</h5>
                            <h5 class="card-title text-center" *ngIf="heading3">Revised data of Awards_medals in sports and cultural activities event wise_2</h5>
                            <div id="detail" class="text-center">
                                <pdf-viewer [src]="src" [render-text]="true" style="display: block;" id="list-view"></pdf-viewer>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>